import { useRef, useCallback } from 'react'

import {
  useOverlayState,
  changeOverlay,
  removeOverlay,
} from '../../firebase/hooks/useOverlays'
import { ChyronTypeDTO } from '../../firebase/model/chyron-model'
import { useSpeakersQuery } from '../../sharedLegacy/hooks/useSpeakersQuery'

const useParticipantIntroOverlay = () => {
  const overlay = useOverlayState()
  const { data: speakers = [] } = useSpeakersQuery()

  const lastShownTime = useRef(new Map())

  const removeParticipantIntroOverlay = useCallback(() => {
    if (overlay?.type === 'speaker') {
      removeOverlay()
    }
  }, [overlay])

  const setParticipantIntroOverlay = useCallback(
    (participantId) => {
      // check the time the participant was shown last
      const now = Date.now()
      const participantLastShownTime = lastShownTime.current.get(participantId)
      const speaker = speakers.find((s) => s.id === participantId)

      // In the case where a user was added to the webinar after the webinar was
      //  loaded, there might not be a speaker to find yet, so we guard against
      //  not having the name to not show an empty speaker card.
      if (!speaker) return

      const { name, title = '', isShowingTitleCard } = speaker

      // There is an option to turn of the showing of TV cards for speakers. If
      //  this option have been toggled off, the we don't show the TV card.
      if (!isShowingTitleCard) return

      /*
       * Check the time the participant was shown last time
       * If he/she was not never shown or the last time he/she was shown is more than 20 seconds than
       * we show the intro for that participant.
       * In any other case we just clear the participant overlay
       */
      if (
        participantLastShownTime === undefined ||
        now - participantLastShownTime > 20000
      ) {
        changeOverlay({
          type: ChyronTypeDTO.Speaker,
          data: { name, title },
        })

        lastShownTime.current.set(participantId, now)
      } else {
        removeParticipantIntroOverlay()
      }
    },
    [speakers, removeParticipantIntroOverlay]
  )

  return { setParticipantIntroOverlay, removeParticipantIntroOverlay }
}

export default useParticipantIntroOverlay
